module.exports = __webpack_public_path__ + "static/media/team3.01fd0d83.png";